/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useCallback, useState } from "react";
import { AllCollapsedContext } from "./all-collapsed.context";

/**
 * @type {import('react').FC<AllCollapsedProviderProps>}
 */
export const AllCollapsedProvider = (props) => {
    
    const children = props?.children;
    
    /** @type {boolean|null} */
    const initialState = null;
    const [allCollapsed, setAllCollapsed] = useState(initialState);

    const expandAll = useCallback(() => {
        setAllCollapsed(false);
    }, []);

    const collapseAll = useCallback(() => {
        setAllCollapsed(true);
    }, []);

    const clearCollapse = useCallback(() => {
        setAllCollapsed(null);
    }, []);

    /** @type {AllCollapsedContext} */
    const context = {
        allCollapsed,
        expandAll,
        collapseAll,
        clearCollapse
    };

    return (
        <AllCollapsedContext.Provider value={context}>
            {children}
        </AllCollapsedContext.Provider>
    );
};

/**
 * @typedef {object} AllCollapsedProviderProps
 * @property {import('react').ReactNode} children
 */
